import { fetcher } from '@commenda/utils';
import {
  IIndirectTaxCreateRegistrationV2Params,
  IIndirectTaxCreateRegistrationV2Response,
} from './types';

export async function createIndirectTaxRegistration(
  body: IIndirectTaxCreateRegistrationV2Params
): Promise<{
  success: boolean;
  data?: IIndirectTaxCreateRegistrationV2Response;
  error?: string;
}> {
  try {
    const response = await fetcher(
      'new-sales-tax/registrations-v2',
      { method: 'POST', body },
      undefined
    );

    if (!response.ok) {
      const errorData = await response.json();
      const errorMessage =
        errorData?.error?.detail?.description ||
        errorData?.error?.title ||
        errorData?.message ||
        'Failed to create registration';
      return {
        success: false,
        error: errorMessage,
      };
    }

    const data: IIndirectTaxCreateRegistrationV2Response = await response.json();
    return {
      success: true,
      data,
    };
  } catch (error) {
    const errorMessage =
      error instanceof Error ? error.message : 'Failed to create registration';
    return {
      success: false,
      error: errorMessage,
    };
  }
}
